import React from 'react';
import { RegularButton } from 'fronton-react';
import { cx } from 'linaria';
import { UOMS } from 'features/product-info/constants';
import { isCorrectPriceUnitsForLaminateProjectPrice } from 'features/product-info/utils';
import { useTranslation } from 'react-i18next';
import { addToBasketSticky } from 'common/components/product-price-view/sticky.styles';
import { ButtonWithoutCounterProps } from './types';

export const DATA_QA_PRODUCT_CART_BUTTON = 'product-cart-button';

export const ButtonWithoutCounter: React.FC<ButtonWithoutCounterProps> = ({
  onBasketChange,
  productId,
  measurementSettings,
  mainPriceUnitSlug,
  additionalPriceUnitSlug,
  configurationArea,
  isLaminateCalc,
  firstPrice,
  secondPrice,
  size = 'l',
  isStickyPanel,
  configurationPriceCoefficient,
}) => {
  const { t } = useTranslation();

  const isCorrectUomForLaminateProjectPrice = isCorrectPriceUnitsForLaminateProjectPrice({
    mainPriceUnit: mainPriceUnitSlug,
    additionalPriceUnit: additionalPriceUnitSlug,
  });

  const isShowProjectPrice =
    Boolean(configurationArea) && isCorrectUomForLaminateProjectPrice && isLaminateCalc;

  const stickyPanelStyle = isStickyPanel ? addToBasketSticky : '';
  const basketNewStyle = cx(stickyPanelStyle);

  const handleAddToCart = () => {
    const step = measurementSettings?.step || 1;
    let initialSteps = Math.round(1 / step);
    if (step * initialSteps !== 1) {
      initialSteps += 1;
    }
    if (step > 1) {
      initialSteps = 1;
    }
    if (isShowProjectPrice && !!secondPrice?.price) {
      const priceBox = mainPriceUnitSlug === UOMS.CAR ? firstPrice.price : secondPrice.price;
      const priceM2 =
        mainPriceUnitSlug === UOMS.M2 || mainPriceUnitSlug === UOMS.MTK
          ? firstPrice.price
          : secondPrice.price;
      const areaPerBox = priceBox / priceM2;
      const priceMultiplier = configurationPriceCoefficient ? configurationPriceCoefficient : 1;
      const amountBox = Math.ceil(((configurationArea as number) / areaPerBox) * priceMultiplier);
      onBasketChange(productId, amountBox);
    } else {
      onBasketChange(productId, step * initialSteps);
    }
  };

  return (
    <RegularButton
      className={basketNewStyle}
      data-qa={DATA_QA_PRODUCT_CART_BUTTON}
      onClick={handleAddToCart}
      aria-label={t('product-info.add-to-basket.aria-label.add-to-cart')}
      size={size}
      wide
    >
      {t('product-info.add-to-basket.button.add-to-cart')}
    </RegularButton>
  );
};
